export default __webpack_public_path__ + "static/media/license_example.109e5908.png";